var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRfqBox2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 69,
    width: 79,
    height: 40,
    fill: "#DBE3EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.0282 104.037H91.1825V109.091H75.6365L90.5167 77.0909H98.1215L103.329 87.6306V109.091H97.414V104.037H101.568L94.2983 87.2205L87.0282 104.037Z",
    fill: "#06CEA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2843 98.5476C54.2843 99.4758 53.9149 99.8822 53.2592 100.538C52.6034 101.198 51.7122 101.078 50.784 101.078H36.5662C34.636 101.078 33.0659 100.483 33.0659 98.5477C33.0659 96.6175 34.636 96.0172 36.5662 96.0172H50.784C51.7122 96.0172 52.6034 95.9018 53.2592 96.5575C53.9149 97.2132 54.2843 97.6194 54.2843 98.5476ZM25.2705 35.6028H63.6069L53.6465 52.1573H15.3101L25.2705 35.6028ZM106.627 35.6028L117.072 53.127H78.251L68.7708 35.6028H106.627ZM103.117 108.629L103.113 57.2183H76.1956C74.9303 57.2183 73.762 56.5302 73.1432 55.422L68.2254 45.009L68.23 108.632L103.117 108.629ZM28.2856 57.2183V108.632H63.658L63.6626 45.009L58.2599 55.422C57.6411 56.5303 56.4775 57.2183 55.2076 57.2183H28.2856ZM20.6522 33.3115L10.1514 52.0002C9.53721 53.0808 9.54644 54.4108 10.1745 55.4867C10.8025 56.5626 11.9569 57.223 13.1991 57.223H23.2244L23.229 106.426C23.2336 110.166 26.2629 113.2 30.008 113.204H101.39C105.135 113.2 108.164 110.166 108.174 106.426V57.2183H118.199C119.446 57.2183 120.591 56.5579 121.219 55.4819C121.847 54.4106 121.856 53.0807 121.247 52.0001L110.746 33.3114C110.127 32.2032 108.959 31.5151 107.694 31.5151H23.6954C22.4302 31.5151 21.2664 32.2033 20.6522 33.3115Z",
    fill: "#3B4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfqBox2);
export default __webpack_public_path__ + "static/media/rfq-box2.3aac7be1d5fbe05b52707620d89aaf7c.svg";
export { ForwardRef as ReactComponent };